module.exports = __webpack_public_path__ + "img/wood2@2x.f7650679.png";